export default __webpack_public_path__ + "static/epilogue-91dd35f085b43d4e95a7cd223583d907.svg";